// extracted by mini-css-extract-plugin
module.exports = {"container":"_3mXpaz","form":"_1Iyl13"};